import '../../frame-selector/frame-selector';

import BaseBuyBox from '@zeg/base-light-module/frontend/components/structures/_buy-box/buy-box/buy-box.class';
import { defineElement, html } from '@webtides/element-js';
import style from './buy-box.css';

import { unsafeHTML } from 'lit-html/directives/unsafe-html';

export default class BuyBox extends BaseBuyBox {
    constructor() {
        super({ styles: [style] });
    }

    templateBackgroundImage() {
        if (!this.backgroundImage) {
            return '';
        }

        return html`
            <div class="absolute inset-0 overflow-hidden hidden md:block">${unsafeHTML(this.backgroundImage)}</div>
        `;
    }
}

defineElement('buy-box', BuyBox);
